import { events } from '@/app/events/events';
import { CursorMode, inlineEditorKeyboard } from '@/app/gridGL/HTMLGrid/inlineEditor/inlineEditorKeyboard';
import { inlineEditorMonaco } from '@/app/gridGL/HTMLGrid/inlineEditor/inlineEditorMonaco';
import { LINE_HEIGHT } from '@/app/web-workers/renderWebWorker/worker/cellsLabel/CellLabel';
import { atom } from 'jotai';

export interface InlineEditorState {
  visible: boolean;
  formula: boolean;
  left: number;
  top: number;
  height: number;
  editMode: boolean;
}

export const defaultInlineEditor: InlineEditorState = {
  visible: false,
  formula: false,
  left: 0,
  top: 0,
  height: LINE_HEIGHT,
  editMode: false,
};

const inlineEditorBaseAtom = atom<InlineEditorState>(defaultInlineEditor);

export const inlineEditorAtom = atom(
  (get) => get(inlineEditorBaseAtom),
  (get, set, newValue: InlineEditorState) => {
    const oldValue = get(inlineEditorBaseAtom);
    set(inlineEditorBaseAtom, newValue);

    // Focus the Monaco editor when becoming visible, after React has rendered
    if (newValue.visible && !oldValue.visible) {
      requestAnimationFrame(() => {
        inlineEditorMonaco.focus();
      });
    }
    inlineEditorKeyboard.cursorMode = newValue.editMode ? CursorMode.Edit : CursorMode.Enter;
    events.emit('setDirty', { cursor: true });
  }
);
